export default () => {
  return {
    //region responsive
    mobile: window.innerWidth < 768,
    desktopImage: null,
    mobileImage: null,
    setScreen() {
      this.mobile = window.innerWidth < 768
    },
    setResponsiveImages(mobile, desktop) {
      this.mobileImage = mobile
      this.desktopImage = desktop
    },
    reset() {
      this.setScreen()
      this.desktopImage = null
      this.mobileImage = null
    },
    //endregion
    //region Modal
    openModal: false,
    imageSrc: '',
    setModal(src) {
      this.openModal = !this.openModal
      this.imageSrc = src
      if (this.openModal) {
        document.querySelector('body').classList.add('overflow-y-hidden')
      }
    },
    closeModal() {
      this.openModal = false
      document.querySelector('body').classList.remove('overflow-y-hidden')
    },
    //endregion
    //region Collapsible tab
    collapsibleTabs: document.querySelectorAll('.product__accordion'),
    setCollapsibleTabDetails(e) {
      this.collapsibleTabs?.forEach(tab => {
        let details = tab?.querySelector('details')

        if (details === null) return

        if (details?.hasAttribute("open")) {
          e.preventDefault()
          details?.classList?.add("closing")
        }

        details?.addEventListener("animationend", (e) => {
          if (e?.animationName === "close") {
            details?.removeAttribute("open")
            details?.classList?.remove("closing")
          }
        });
      })
    },
    //endregion
  }
}
